import {useEffect, useState} from "react";
import {DataAPI} from "./services/API";
import {useHistory, useLocation} from "react-router-dom";

const useReports = () => {

    let [reports, setReports] = useState([]);

    useEffect(() => {
        DataAPI.getReports().then((response) => {
            setReports(response.reports);
        });
    }, []);

    return reports;
}

/**
 * Śledzi dopasowanie media query, np. '(max-width: 64em)'.
 * Pozwala renderować inny układ zamiast tylko przestylowywać istniejący.
 */
const useMediaQuery = (query: string) => {

    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const list = window.matchMedia(query);
        const onChange = (e) => setMatches(e.matches);
        //stan mógł się zmienić między pierwszym renderem a podpięciem listenera
        setMatches(list.matches);
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

const useNavigateModal = () => {
    let history = useHistory();
    let location = useLocation();

    return (url) => {
        history.push({
            pathname: url,
            state: { background: location }
        })
    }

}

export {
    useReports,
    useNavigateModal,
    useMediaQuery
}